import React from "react"

import * as styles from './backBtn.module.scss';

const BackBtn = () => (
  <button onClick={() => window.history.back()} className={styles.back}>&larr; {`Go back`}</button>
)

export default BackBtn
